<template>
  <div>
    <a @click="openMessage">
      <span :class="fromClass(message)" v-html="shortenedChatMessage(message)" />
      <v-icon v-if="message && message.messageattachmentSet && getAttachments(message.messageattachmentSet, 'VIDEO').length > 0">
        mdi-video
      </v-icon>
      <v-icon v-if="message && message.messageattachmentSet && getAttachments(message.messageattachmentSet, 'AUDIO').length > 0">
        mdi-microphone
      </v-icon>
      <v-icon v-if="message && message.messageattachmentSet && getAttachments(message.messageattachmentSet, 'IMAGE').length > 0">
        mdi-image
      </v-icon>
      <div v-if="message && message.sentDate" class="caption">{{ message.sentDate | moment("from") }}</div>
    </a>

    <v-dialog v-model="messageDialog" width="500">
      <v-card v-if="last3Messages.length > 0">
        <v-alert type="info">Last 3 messages</v-alert>
        <chat-message-view v-for="m in last3Messages" :key="m.id" :message="m" />
      </v-card>
      <v-card v-else>
        <v-progress-circular :indeterminate="true" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { CHAT_QUERY } from "@/constants/graphql/chat/chat";
import { decodeId } from "@/lib/string";
import ChatMixin from "@/components/shared/mixins/ChatMixin";
import ChatMessageView from "@/components/chats/ChatMessageView";

export default {
  name: "LastMessage",
  mixins: [ChatMixin],
  components: {
    ChatMessageView,
  },
  props: {
    message: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      messageDialog: false,
      last3Messages: [],
    };
  },
  methods: {
    async openMessage() {
      this.messageDialog = true;
      this.$emit("viewed-message", this.message);
      const result = await this.$apollo.query({
        query: CHAT_QUERY,
        fetchPolicy: "no-cache",
        variables: {
          chatId: decodeId(this.message.chat.id),
        },
      });
      this.last3Messages = result.data.chat.last3Messages.reverse();
    },
    shortenedChatMessage(message) {
      if (!message) return "";

      let lastMessage = "";
      let lastMessageText = message.text;
      if (lastMessageText && lastMessageText.length > 10) {
        lastMessageText =
          lastMessageText
            .trim()
            .split(" ")
            .slice(0, 10)
            .join(" ") + "...";
      }
      lastMessage = `${message.user.firstName}: ${lastMessageText ? lastMessageText : ""}`;
      return lastMessage;
    },
    fromClass(message) {
      // if the last message is not from a staff member, then we highlight it.
      if (!message || message.user?.isStaff) {
        return "";
      }
      return "font-weight-bold metric-yellow";
    },
  },
};
</script>
